/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useContext, useEffect, useState } from 'react'
import { toast } from 'react-hot-toast';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';

//import BackButton from '../../Components/Buttons/BackButton'
import PrimaryButton from '../../Components/Buttons/PrimaryButton'
import SecondaryButton from '../../Components/Buttons/SecondaryButton'
import FormInput from '../../Components/FormInput/FormInput'
import FormPlacesNearByInput from '../../Components/FormInput/FormPlacesNearByInput'
import Header from '../../Components/Header/Header'
import MultiSelect from '../../Components/MultiSelect/MultiSelect';
import { authContext } from '../../store/AuthContext';

const EditSite = () => {

    const defaultState = {
        title: '',
        name: '',
        address: '',
        hira: '',
        description: '',
        price: '',
        overviewTitle: '',
        overviewDescription: '',
        propertyType: '',
        unitSize: '',
        numberOfUnits: '',
        numberOfTower: '',
        numberOfFloors: '',
        landArea: '',
        possessionYear: '',
        possessionStatus: '',
        whyToChoose: '',
        whyToChooseTitle: '',
        locationTitle: '',
        locationDescription: '',
        mapUrl: '',
        placesNearBy: [{}],
        floorPlanTitle: '',
        floorPlanDescription: '',
        amenitiesTitle: '',
        amenitiesDescription: '',
        amenities: '',
        brochure: null,
        headerScript: '',
        bodyScript: '',
        footerScript: '',
        thankYouScript: '',
        galleryTitle: '',
        galleryDescription: ''
    }

    const serverURL = process.env.REACT_APP_SERVER_URL;
    const token = JSON.parse(localStorage.getItem('token'));

    const history = useHistory();

    const authCtx = useContext(authContext);

    if (authCtx.adminType !== 'super' && authCtx.adminType !== 'data') {
        history.push('/form');
    }

    const params = useParams();

    const [property, setProperty] = useState(defaultState);
    const [editData, setEditData] = useState({});
    const [uploadBrochure, setUploadBrochure] = useState(false);
    const [removeBrochure, setRemoveBrochure] = useState(false);
    const [newBrochure, setNewBrochure] = useState(null);


    if (!params.id || params.id.length === 0) {
        history.push('/sites');
    }

    const getSite = async () => {
        const res = await toast.promise(
            axios({
                method: 'GET',
                url: `${serverURL}/api/sites/${params.id}`,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }), {
            loading: "Fetching...",
            success: "Data fetched successfully",
            error: "Couldn't fetch the data"
        }
        )
        if (res && res.status === 200) {
            setProperty({ ...res.data.data, amenities: res.data.data.amenities.map((item) => item._id) });
            return;
        }

        history.push('/sites');
    }

    const getBrochure = async () => {
        if (property._id) {
            const res = await axios({
                method: "GET",
                url: `${serverURL}/api/brochure/${property._id}`
            })
            if (res && res.status === 200) {
                setProperty({
                    ...property,
                    brochure: res.data.data.path
                })
            }
        }

    }

    const textInputChangeHandler = (event) => {
        setProperty((prevState) => {
            return {
                ...prevState,
                [event.target.name]: event.target.value
            }
        })
        setEditData((prevState) => {
            return {
                ...prevState,
                [event.target.name]: event.target.value
            }
        })
    }

    const editorInputChangeHandler = (data) => {
        setProperty((prevState) => {
            return {
                ...prevState,
                [data.name]: data.value
            }
        })
        setEditData((prevState) => {
            return {
                ...prevState,
                [data.name]: data.value
            }
        })
    }

    const PlacesNearbyHandler = (data) => {
        setProperty((prevState) => {
            return {
                ...prevState,
                placesNearBy: data
            }
        })
        setEditData((prevState) => {
            return {
                ...prevState,
                placesNearBy: data
            }
        })
    }

    const createPropertyHandler = async (event) => {
        event.preventDefault();

        if (removeBrochure === true) {
            await axios({
                method: "DELETE",
                url: `${serverURL}/api/brochure/${property._id}`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            })
        }

        if (uploadBrochure === true) {
            const newFormData = new FormData();

            newFormData.append('property', property._id);
            newFormData.append('brochure', newBrochure);

            try {
                await axios({
                    method: "POST",
                    url: `${serverURL}/api/brochure`,
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "multipart/form-data"
                    },
                    data: newFormData
                })
            } catch (error) {

            }

        }

        let data = { ...editData };

        data.placesNearBy = JSON.stringify(data.placesNearBy);
        data.amenities = JSON.stringify(data.amenities);

        const res = await toast.promise(
            axios({
                method: 'PUT',
                url: `${serverURL}/api/sites/${params.id}`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                data
            }), {
            loading: "Creating...",
            success: "Data created successfully",
            error: "Couldn't create the data"
        }
        )

        if (res && res.status === 200) {
            history.push('/sites');
        }
    }

    const amenityChangeHandler = (selectedAmenities) => {
        setProperty((prevState) => {
            return {
                ...prevState,
                amenities: selectedAmenities
            }
        })
        setEditData((prevState) => {
            return {
                ...prevState,
                amenities: selectedAmenities
            }
        })
    }

    const brochureChangeHandler = (e) => {
        setUploadBrochure(true);
        setNewBrochure(e.target.files[0]);
    }

    const viewBrochure = () => {
        window.open(`${serverURL}/${property.brochure}`, "_blank");
    }

    const deleteBrochure = () => {
        setRemoveBrochure(true);
        setProperty((prevState) => {
            return {
                ...prevState,
                brochure: null
            }
        })
    }

    useEffect(() => {
        if (property._id) {
            getBrochure();
        }
    }, [property._id])

    useEffect(() => {
        getSite();
    }, [])

    return (
        <Fragment>
            <Header />
            <div className='container' >
                {/* {<BackButton to='/sites' >Back to Sites</BackButton>} */}
                <h3 className='heading-primary mt-20' >Edit Site</h3>
                <hr />
                <div className="main">
                    <div className="form pd-2">
                        <form className='row'>
                            <div className='col-lg-4'>
                                <FormInput onChange={textInputChangeHandler} value={property.name} autoComplete='off' type='text' label='Site Name' id='name' />
                            </div>
                            <div className='col-lg-4'>
                                <FormInput onChange={textInputChangeHandler} value={property.propertyType} autoComplete='off' type='text' label='Property Type' id='propertyType' />
                            </div>
                            <div className='col-lg-4'>
                                <FormInput onChange={textInputChangeHandler} value={property.address} autoComplete='off' type='text' label='Address' id='address' />
                            </div>
                            <div className='col-lg-12'>
                                <FormInput onChange={textInputChangeHandler} value={property.hira} autoComplete='off' type='text' label='RERA' id='hira' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} value={property.title} autoComplete='off' type='text' label='Title' id='title' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} value={property.overviewTitle} autoComplete='off' type='text' label='Overview Title' id='overviewTitle' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={editorInputChangeHandler} value={property.description} autoComplete='off' type='editor' label='Description' id='description' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={editorInputChangeHandler} value={property.overviewDescription} autoComplete='off' type='editor' label='Overview Description' id='overviewDescription' />
                            </div>
                            <div className='col-lg-3'>
                                <FormInput onChange={textInputChangeHandler} value={property.price} autoComplete='off' type='text' label='Price' id='price' />
                            </div>
                            <div className='col-lg-3'>
                                <FormInput onChange={textInputChangeHandler} value={property.unitSize} autoComplete='off' type='text' label='Unit Size' id='unitSize' />
                            </div>
                            <div className='col-lg-3'>
                                <FormInput onChange={textInputChangeHandler} value={property.numberOfUnits} autoComplete='off' type='text' label='Number of Units' id='numberOfUnits' />
                            </div>
                            <div className='col-lg-3'>
                                <FormInput onChange={textInputChangeHandler} value={property.numberOfTower} autoComplete='off' type='text' label='Number of Towers' id='numberOfTower' />
                            </div>
                            <div className='col-lg-3'>
                                <FormInput onChange={textInputChangeHandler} value={property.numberOfFloors} autoComplete='off' type='text' label='Number of Floors' id='numberOfFloors' />
                            </div>
                            <div className='col-lg-3'>
                                <FormInput onChange={textInputChangeHandler} value={property.landArea} autoComplete='off' type='text' label='Land Area' id='landArea' />
                            </div>
                            <div className='col-lg-3'>
                                <FormInput onChange={textInputChangeHandler} value={property.possessionYear} autoComplete='off' type='text' label='Possession Year' id='possessionYear' />
                            </div>
                            <div className='col-lg-3'>
                                <FormInput onChange={textInputChangeHandler} value={property.possessionStatus} autoComplete='off' type='text' label='Possession Status' id='possessionStatus' />
                            </div>
                            <div className='col-lg-12'>
                                <FormInput onChange={textInputChangeHandler} value={property.whyToChooseTitle} autoComplete='off' type='text' label='Why To Choose Title' id='whyToChooseTitle' />
                            </div>
                            <div className='col-lg-12'>
                                <FormInput onChange={editorInputChangeHandler} value={property.whyToChoose} autoComplete='off' type='editor' label='Why To Choose' id='whyToChoose' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} value={property.locationTitle} autoComplete='off' type='text' label='Location Title' id='locationTitle' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} value={property.locationDescription} autoComplete='off' type='text' label='Location Description' id='locationDescription' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} value={property.galleryTitle} autoComplete='off' type='text' label='Gallery Title' id='galleryTitle' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} value={property.galleryDescription} autoComplete='off' type='text' label='Gallery Description' id='galleryDescription' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} value={property.floorPlanTitle} autoComplete='off' type='text' label='Floor Plan Title' id='floorPlanTitle' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} value={property.floorPlanDescription} autoComplete='off' type='text' label='Floor Plan Description' id='floorPlanDescription' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} value={property.amenitiesTitle} autoComplete='off' type='text' label='Amenities Title' id='amenitiesTitle' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} value={property.amenitiesDescription} autoComplete='off' type='text' label='Amenities Description' id='amenitiesDescription' />
                            </div>
                            <div className='col-lg-12'>
                                <div className='form-group'>
                                    <label>Select Amenities</label>
                                    <MultiSelect onChange={amenityChangeHandler} selected={property.amenities} />
                                </div>
                            </div>
                            <div className='col-lg-12'>
                                <div className='form-group'>
                                    <FormInput onChange={textInputChangeHandler} value={property.mapUrl} autoComplete='off' type='text' label='Map Url' id='mapUrl' />
                                </div>
                            </div>
                            <div style={{ margin: '15px', width: '100%', backgroundColor: '#f7f7f7', padding: '1rem' }} >
                                <label style={{}} >Brochure</label>
                                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }} >
                                    {property.brochure && <SecondaryButton type='button' onClick={viewBrochure}  >View Brochure</SecondaryButton>}
                                    {property.brochure && <PrimaryButton type='button' onClick={deleteBrochure}  >Delete Brochure</PrimaryButton>}
                                    <input onChange={brochureChangeHandler} type='file' accept='application/pdf' />
                                </div>
                            </div>
                            <div style={{ backgroundColor: '#f7f7f7', padding: '1rem 0', width: '100%', margin: '1rem 15px' }} >
                                <div className='col-lg-12'>
                                    <FormPlacesNearByInput propertyID={params.id} onChange={PlacesNearbyHandler} />
                                </div>
                            </div>
                            <div className='col-lg-12' >
                                <div className="form-group">
                                    <label className='d-block' >Header Script</label>
                                    <textarea className='form-control shadow-none' onChange={textInputChangeHandler} name="headerScript" value={property.headerScript} style={{ minHeight: "140px" }}  ></textarea>
                                </div>
                            </div>
                            <div className='col-lg-12'>
                                <div className="form-group">
                                    <label className='d-block' >Body Script</label>
                                    <textarea className='form-control shadow-none' style={{ minHeight: "140px" }} onChange={textInputChangeHandler} name="bodyScript" value={property.bodyScript}  ></textarea>
                                </div>
                            </div>
                            <div className='col-lg-12'>
                                <div className="form-group">
                                    <label className='d-block' >Footer Script</label>
                                    <textarea className='form-control shadow-none' style={{ minHeight: "140px" }} onChange={textInputChangeHandler} name="footerScript" value={property.footerScript}  ></textarea>
                                </div>
                            </div>
                            <div className='col-lg-12'>
                                <div className="form-group">
                                    <label className='d-block' >Thank You Page Script</label>
                                    <textarea className='form-control shadow-none' style={{ width: '100%', minHeight: "140px" }} onChange={textInputChangeHandler} name="thankYouScript" value={property.thankYouScript}  ></textarea>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <hr />
                <div className='add-site-actions' >
                    <SecondaryButton style={{ width: '20%' }} type='button' onClick={createPropertyHandler} >Submit</SecondaryButton>
                    <PrimaryButton onClick={() => {
                        history.push('/sites')
                    }} style={{ width: '20%' }} type='button' >Cancel</PrimaryButton>
                </div>
                <br /><br />
            </div>
        </Fragment >
    )
}

export default EditSite